import React from 'react';
import { StyledBreakWordContainer } from '../../../styled';

const AccessFolder = ({ row, handleFolderClick }) => {
  const { enable_folder_access: enableFolderAccess } = row.original;

  return (
    <div className='flex w-40'>
      <StyledBreakWordContainer>
        <span
          className={`${enableFolderAccess && 'cursor-pointer text-blue-500'}`}
          onClick={() => {
            if (!enableFolderAccess) return;
            handleFolderClick(row.original.folder, row.original.id);
          }}>
          {row.values?.portfolio_name || '-'}
        </span>
      </StyledBreakWordContainer>
    </div>
  );
};
export default AccessFolder;
